import React from 'react';
import { motion } from 'framer-motion';
import { 
  FaGraduationCap, 
  FaChalkboardTeacher,
  FaInstagram,
  FaFacebookF 
} from 'react-icons/fa';
import { 
  FiAward, 
  FiBookOpen, 
  FiUsers, 
  FiGlobe 
} from 'react-icons/fi';

// Using a placeholder image URL
const campusBg = 'https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80';

// // Animation variants
// const fadeIn = {
//   hidden: { opacity: 0, y: 20 },
//   visible: { 
//     opacity: 1, 
//     y: 0,
//     transition: { duration: 0.6 }
//   }
// };

// const staggerContainer = {
//   hidden: { opacity: 0 },
//   visible: {
//     opacity: 1,
//     transition: {
//       staggerChildren: 0.1
//     }
//   }
// };

// const stats = [
//   { icon: <FaGraduationCap className="w-8 h-8" />, count: '10,000+', label: 'Students Enrolled' },
//   { icon: <FaChalkboardTeacher className="w-8 h-8" />, count: '500+', label: 'Expert Faculty' },
//   { icon: <FiAward className="w-8 h-8" />, count: '95%', label: 'Graduation Rate' },
//   { icon: <FiGlobe className="w-8 h-8" />, count: '50+', label: 'Global Partners' }
// ];

// const features = [
//   {
//     icon: <FiBookOpen className="w-10 h-10 text-black" />,
//     title: 'Comprehensive Programs',
//     description: 'Wide range of undergraduate and graduate programs designed to meet industry demands.'
//   },
//   {
//     icon: <FiAward className="w-10 h-10 text-black" />,
//     title: 'Accredited Excellence',
//     description: 'Fully accredited institution with nationally recognized programs and faculty.'
//   },
//   {
//     icon: <FiUsers className="w-10 h-10 text-black" />,
//     title: 'Diverse Community',
//     description: 'Vibrant campus life with students from over 50 countries worldwide.'
//   },
//   {
//     icon: <FiGlobe className="w-10 h-10 text-black" />,
//     title: 'Global Opportunities',
//     description: 'Study abroad programs and international partnerships for a global perspective.'
//   }
// ];

// const Home = () => {
//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* Hero Section */}
//       <section className="relative min-h-[500px] h-screen max-h-[900px] overflow-hidden">
//         {/* Background Image */}
//         <div className="absolute inset-0 w-full h-full">
//           {/* <img 
//             src={campusBg}
//             alt="University Campus"
//             className="w-full h-full object-cover"
//             style={{
//               position: 'absolute',
//               top: 0,
//               left: 0,
//               width: '100%',
//               height: '100%',
//               objectFit: 'cover',
//               zIndex: 0
//             }}
//           /> */}

//            <video
//         autoPlay
//         loop
//         muted
//         playsInline
//         poster={campusBg}
//         className="w-full h-full object-cover"
//         style={{
//           position: 'absolute',
//           top: 0,
//           left: 0,
//           zIndex: 0
//         }}
//       >
//         <source src={Cumpusbg} type="video/mp4" />
//         Your browser does not support the video tag.
//       </video>
//         </div>
        
//         {/* Hero Content */}
        <div className="absolute inset-0 bg-black/50 flex items-center justify-center z-10 p-4">
          <div className="text-center text-white max-w-4xl mx-auto">
            <motion.h1 
              className="text-3xl md:text-5xl font-bold mb-6 leading-tight"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              Empowering Future Leaders Through Excellence in Education
            </motion.h1>
            <motion.p 
              className="text-lg md:text-xl mb-8 max-w-2xl mx-auto"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              Join our vibrant academic community and unlock your potential with world-class education and endless opportunities.
            </motion.p>
          </div>
        </div>
//         <div className="relative max-w-7xl mx-auto h-full flex items-center px-4 sm:px-6 lg:px-8 z-10">
//           <motion.div 
//             className="max-w-3xl text-center md:text-left text-white relative z-10"
//             initial="hidden"
//             animate="visible"
//             variants={staggerContainer}
//           >
//             {/* <motion.span 
//               className="inline-block bg-white/20 backdrop-blur-sm text-white text-sm font-semibold px-4 py-1.5 rounded-full mb-6 border border-white/30"
//               variants={fadeIn}
//             >
//               Empowering Future Leaders
//             </motion.span>
//              */}
//             {/* <motion.h1 
//               className="text-4xl md:text-5xl lg:text-6xl font-extrabold mb-6 leading-tight text-white drop-shadow-lg"
//               variants={fadeIn}
//             >
//               Transform Your Future Through <span className="text-white">Excellence</span> in Education
//             </motion.h1> */}
            
//             {/* <motion.p 
//               className="text-xl mb-8 max-w-2xl mx-auto md:mx-0 text-white drop-shadow"
//               variants={fadeIn}
//             >
//               Join our vibrant academic community and discover endless opportunities for growth, innovation, and success in your chosen field.
//             </motion.p> */}
//           </motion.div>
//         </div>
//       </section>

//       {/* Stats Section */}
//       <section className="bg-primary text-white py-16">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
//             {stats.map((stat, index) => (
//               <motion.div 
//                 key={index}
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ delay: index * 0.1 }}
//                 className="text-center p-6 bg-white/10 rounded-lg backdrop-blur-sm hover:bg-white/20 transition-colors"
//               >
//                 <div className="flex justify-center mb-3 text-white">
//                   {stat.icon}
//                 </div>
//                 <div className="text-3xl font-bold text-white mb-1">{stat.count}</div>
//                 <div className="text-white text-sm font-medium">{stat.label}</div>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Features Section */}
      // <section className="pt-20 pb-20 bg-gray-50">
      //   <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      //     <div className="text-center mb-16">
      //       <h2 className="text-base font-black text-black mb-3 uppercase tracking-widest">
      //         Why Choose Us
      //       </h2>
      //       <h2 className="text-3xl md:text-4xl font-bold text-black mb-4">
      //         Experience <span className="text-black">Excellence</span> in Education
      //       </h2>
      //       <div className="w-20 h-1 bg-black mx-auto mb-8 rounded-full"></div>
      //       <p className="text-lg text-black/80 max-w-3xl mx-auto">
      //         We are committed to providing a transformative educational experience that prepares students for success in an ever-changing world.
      //       </p>
      //     </div>
          
      //     <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
      //       {features.map((feature, index) => (
      //         <motion.div
      //           key={index}
      //           initial={{ opacity: 0, y: 20 }}
      //           whileInView={{ opacity: 1, y: 0 }}
      //           viewport={{ once: true }}
      //           transition={{ delay: index * 0.1 }}
      //           className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-all border border-gray-100 hover:border-primary/20"
      //         >
      //           <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-4 text-black">
      //             {feature.icon}
      //           </div>
      //           <h3 className="text-xl font-semibold text-gray-900 mb-2">{feature.title}</h3>
      //           <p className="text-gray-600">{feature.description}</p>
      //         </motion.div>
      //       ))}
      //     </div>
      //   </div>
      // </section>

//       {/* Image Showcase */}
      // <section className="relative py-20 bg-gray-50">
      //   <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      //     <div className="grid md:grid-cols-2 gap-8 items-center">
      //       <motion.div 
      //         className="space-y-6"
      //         initial={{ opacity: 0, x: -20 }}
      //         whileInView={{ opacity: 1, x: 0 }}
      //         viewport={{ once: true }}
      //         transition={{ duration: 0.6 }}
      //       >
      //         <span className="inline-block bg-primary/10 text-black text-base font-extrabold px-5 py-2 rounded-full uppercase tracking-wider">
      //           Our Campus
      //         </span>
      //         <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
      //           A Vibrant Learning <span className="text-black">Environment</span>
      //         </h2>
      //         <p className="text-lg text-black">
      //           Our state-of-the-art campus provides the perfect setting for academic achievement and personal growth. With modern facilities, cutting-edge technology, and inspiring spaces, we create an environment where innovation thrives.
      //           <span className="block mt-4">
      //             Beyond the classroom, students engage in collaborative learning, creative exploration, and real-world projects that foster both intellectual and personal development. From dynamic lecture halls to peaceful study zones, every corner of our campus is designed to motivate and empower.
      //           </span>
      //         </p>
      //       </motion.div>
            
      //       <motion.div 
      //         className="grid grid-cols-2 gap-4"
      //         initial={{ opacity: 0, scale: 0.95 }}
      //         whileInView={{ opacity: 1, scale: 1 }}
      //         viewport={{ once: true }}
      //         transition={{ duration: 0.6, delay: 0.2 }}
      //       >
      //         <div className="aspect-w-1 aspect-h-1">
      //           <img 
      //             src="https://images.unsplash.com/photo-1541339907198-e08756dedf3f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" 
      //             alt="Campus Library"
      //             className="w-full h-full object-cover rounded-lg shadow-lg"
      //           />
      //         </div>
      //         <div className="grid gap-4">
      //           <div className="aspect-w-1 aspect-h-1">
      //             <img 
      //               src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1471&q=80" 
      //               alt="Students in Class"
      //               className="w-full h-full object-cover rounded-lg shadow-lg"
      //             />
      //           </div>
      //           <div className="aspect-w-1 aspect-h-1">
      //             <img 
      //               src="https://images.unsplash.com/photo-1521791055366-0d553872125f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1469&q=80" 
      //               alt="Campus Grounds"
      //               className="w-full h-full object-cover rounded-lg shadow-lg"
      //             />
      //           </div>
      //         </div>
      //       </motion.div>
      //     </div>
      //   </div>
      // </section>

//       {/* Call to Action */}
      // <section className="py-20 bg-gradient-to-r from-primary to-primary-dark text-white">
      //   <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      //     <motion.div
      //       initial={{ opacity: 0, y: 20 }}
      //       whileInView={{ opacity: 1, y: 0 }}
      //       viewport={{ once: true }}
      //       transition={{ duration: 0.5 }}
      //     >
      //       <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">Ready to Begin Your Journey?</h2>
      //       <p className="text-xl text-white max-w-3xl mx-auto">
      //         Take the first step toward your future today. Our admissions team is here to guide you through the application process.
      //         <span className="block mt-4">We're committed to supporting you every step of the way — from choosing the right program to preparing for your first day.</span>
      //         <span className="block mt-4">Join a vibrant community of learners, and start building the future you deserve.</span>
      //       </p>
      //     </motion.div>
      //   </div>
      // </section>
//     </div>
//   );
// };



// Animation variants
const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.6 }
  }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};

const stats = [
  { icon: <FaGraduationCap className="w-8 h-8" />, count: '10,000+', label: 'Students Enrolled' },
  { icon: <FaChalkboardTeacher className="w-8 h-8" />, count: '500+', label: 'Expert Faculty' },
  { icon: <FiAward className="w-8 h-8" />, count: '95%', label: 'Graduation Rate' },
  { icon: <FiGlobe className="w-8 h-8" />, count: '50+', label: 'Global Partners' }
];

const features = [
  {
    icon: <FiBookOpen className="w-10 h-10 text-[#800000]" />,
    title: 'Comprehensive Programs',
    description: 'Wide range of undergraduate and graduate programs designed to meet industry demands.'
  },
  {
    icon: <FiAward className="w-10 h-10 text-[#800000]" />,
    title: 'Accredited Excellence',
    description: 'Fully accredited institution with nationally recognized programs and faculty.'
  },
  {
    icon: <FiUsers className="w-10 h-10 text-[#800000]" />,
    title: 'Diverse Community',
    description: 'Vibrant campus life with students from over 50 countries worldwide.'
  },
  {
    icon: <FiGlobe className="w-10 h-10 text-[#800000]" />,
    title: 'Global Opportunities',
    description: 'Study abroad programs and international partnerships for a global perspective.'
  }
];

// === NEW DATA FOR THE SOCIAL LINKS SECTION ===
const socialLinks = [
  {
    icon: <FaInstagram className="w-8 h-8 text-white" />,
    title: "FIC Group Education",
    description: "Follow our main educational page for daily updates and student stories.",
    url: "https://www.instagram.com/ficgroupedu?igsh=MXZ0Yzk1dzF4cjczbw==",
    bgColor: "bg-gradient-to-br from-pink-500 to-purple-600"
  },
  {
    icon: <FaInstagram className="w-8 h-8 text-white" />,
    title: "First Int'l Consultants",
    description: "Connect with our consultancy team for expert guidance and support.",
    url: "https://www.instagram.com/firstinternationalconsultants?igsh=MTQxNGEzbWExZDB5dw==",
    bgColor: "bg-gradient-to-br from-red-500 to-yellow-500"
  },
  {
    icon: <FaFacebookF className="w-8 h-8 text-white" />,
    title: "FIC Group on Facebook",
    description: "Join our Facebook community for news, events, and live sessions.",
    url: "https://www.facebook.com/share/1GPLcnYGir/",
    bgColor: "bg-gradient-to-br from-blue-600 to-blue-800"
  },
  {
    icon: <FaFacebookF className="w-8 h-8 text-white" />,
    title: "Consultants on Facebook",
    description: "Like our consultancy page to stay informed about our services.",
    url: "https://www.facebook.com/share/16PGet68T6/",
    bgColor: "bg-gradient-to-br from-indigo-500 to-blue-500"
  },
]

const Home = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative min-h-[500px] h-screen max-h-[900px] overflow-hidden">
        <div 
          className="absolute inset-0 w-full h-full z-0"
          style={{
            backgroundImage: `url(${campusBg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        />
        <div className="absolute inset-0 bg-black/40 flex items-center justify-center z-10 p-4">
          <div className="text-center text-white max-w-4xl mx-auto px-4">
            <motion.h1 
              className="text-3xl md:text-5xl font-bold mb-6 leading-tight"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              Empowering Future Leaders Through Excellence in Education
            </motion.h1>
            <motion.p 
              className="text-lg md:text-xl mb-8 max-w-2xl mx-auto"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              Join our vibrant academic community and unlock your potential with world-class education and endless opportunities.
            </motion.p>
          </div>
        </div>
      </section>

      {/* Stats Section */}
       <section className="bg-primary text-white py-16">
         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
           <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
             {stats.map((stat, index) => (
              <motion.div 
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="text-center p-6 bg-white/10 rounded-lg backdrop-blur-sm hover:bg-white/20 transition-colors"
              >
                <div className="flex justify-center mb-3 text-white">
                  {stat.icon}
                </div>
                <div className="text-3xl font-bold text-white mb-1">{stat.count}</div>
                <div className="text-white text-sm font-medium">{stat.label}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="pt-20 pb-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-base font-black text-black mb-3 uppercase tracking-widest">
              Why Choose Us
            </h2>
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-4">
              Experience <span className="text-black">Excellence</span> in Education
            </h2>
            <div className="w-20 h-1 bg-black mx-auto mb-8 rounded-full"></div>
            <p className="text-lg text-black/80 max-w-3xl mx-auto">
              We are committed to providing a transformative educational experience that prepares students for success in an ever-changing world.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-all border border-gray-100 hover:border-primary/20"
              >
                <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-4 text-black">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Image Showcase */}
      <section className="relative py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <motion.div 
              className="space-y-6"
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <span className="inline-block bg-primary/10 text-black text-base font-extrabold px-5 py-2 rounded-full uppercase tracking-wider">
                Our Campus
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                A Vibrant Learning <span className="text-black">Environment</span>
              </h2>
              <p className="text-lg text-black">
                Our state-of-the-art campus provides the perfect setting for academic achievement and personal growth. With modern facilities, cutting-edge technology, and inspiring spaces, we create an environment where innovation thrives.
                <span className="block mt-4">
                  Beyond the classroom, students engage in collaborative learning, creative exploration, and real-world projects that foster both intellectual and personal development. From dynamic lecture halls to peaceful study zones, every corner of our campus is designed to motivate and empower.
                </span>
              </p>
            </motion.div>
            
            <motion.div 
              className="grid grid-cols-2 gap-4"
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <div className="aspect-w-1 aspect-h-1">
                <img 
                  src="https://images.unsplash.com/photo-1541339907198-e08756dedf3f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" 
                  alt="Campus Library"
                  className="w-full h-full object-cover rounded-lg shadow-lg"
                />
              </div>
              <div className="grid gap-4">
                <div className="aspect-w-1 aspect-h-1">
                  <img 
                    src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1471&q=80" 
                    alt="Students in Class"
                    className="w-full h-full object-cover rounded-lg shadow-lg"
                  />
                </div>
                <div className="aspect-w-1 aspect-h-1">
                  <img 
                    src="https://images.unsplash.com/photo-1521791055366-0d553872125f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1469&q=80" 
                    alt="Campus Grounds"
                    className="w-full h-full object-cover rounded-lg shadow-lg"
                  />
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* =============================================== */}
      {/* === START: NEW "CONNECT WITH US" SECTION === */}
      {/* =============================================== */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-base font-black text-black mb-3 uppercase tracking-widest">
              Join Our Community
            </h2>
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-4">
              Connect With Us on Social Media
            </h2>
            <div className="w-20 h-1 bg-black mx-auto mb-8 rounded-full"></div>
            <p className="text-lg text-black/80 max-w-3xl mx-auto">
              Stay up-to-date with the latest news, events, and stories from our vibrant community. Follow us on our social channels.
            </p>
          </div>
          
          <motion.div 
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
          >
            {socialLinks.map((link, index) => (
              <motion.div
                key={index}
                variants={fadeIn}
                className="relative group overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300"
              >
                <div className={`absolute inset-0 ${link.bgColor} transition-transform duration-500 group-hover:scale-110`}></div>
                <a 
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="relative flex flex-col items-center justify-center text-center p-8 h-64 text-white"
                >
                  <div className="mb-4">
                    {link.icon}
                  </div>
                  <h3 className="text-xl font-bold mb-2">{link.title}</h3>
                  <p className="text-sm text-white/80 mb-4">{link.description}</p>
                  <span className="mt-auto inline-block bg-white/20 backdrop-blur-sm text-white text-xs font-semibold px-4 py-2 rounded-full border border-white/30 group-hover:bg-white/30 transition-colors">
                    Visit Page
                  </span>
                </a>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>
      {/* =============================================== */}
      {/* === END: NEW "CONNECT WITH US" SECTION ===== */}
      {/* =============================================== */}

      {/* Call to Action */}
      <section className="py-20 bg-gradient-to-r from-primary to-primary-dark text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">Ready to Begin Your Journey?</h2>
            <p className="text-xl text-white max-w-3xl mx-auto">
              Take the first step toward your future today. Our admissions team is here to guide you through the application process.
              <span className="block mt-4">We're committed to supporting you every step of the way — from choosing the right program to preparing for your first day.</span>
              <span className="block mt-4">Join a vibrant community of learners, and start building the future you deserve.</span>
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Home;